<template>
  <div class="card">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <hr>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <hr>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'card'
  }
</script>
<style>
  .arr-right .breadcrumb-item+.breadcrumb-item::before {
      content: "›";
      vertical-align:top;
      color: #ccc;
      font-size:35px;
      line-height:18px;
  }

  .card label{
      font-size: 16px !important;
      margin-bottom: 0px !important;
      text-transform: none !important;
      color: #000 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/Card.vue